export function createDownloadsByLocationChart(el, apiUrl) {
  if (!el) throw new Error('downloads_by_location: element not found');
  const endpoint = apiUrl || '/analytics/chart';
  const chartId = el.id || 'world-map';

  function computeTopDataFromArrays(labels = [], series = []) {
    const pairs = [];
    for (let i = 0; i < labels.length; i++) {
      const name = String(labels[i] || '').trim();
      const val = Number(series[i] || 0);
      if (!name) continue;
      if (name.toLowerCase() === 'unknown') continue;
      pairs.push([name, val]);
    }
    pairs.sort((a, b) => b[1] - a[1]);
    const top = pairs.slice(0, 10);
    const denom = top.reduce((sum, p) => sum + (Number(p[1]) || 0), 0) || 1;
    const percentMap = {};
    const topLabels = [];
    const topSeries = [];
    const topPercents = [];
    for (let i = 0; i < top.length; i++) {
      const name = top[i][0];
      const val = Number(top[i][1] || 0);
      const pct = Math.round((val * 100.0 / denom) * 100) / 100; // 2dp
      percentMap[name] = pct;
      topLabels.push(name);
      topSeries.push(val);
      topPercents.push(pct);
    }
    return { percentMap, topLabels, topSeries, topPercents };
  }

  function parseData(data) {
    if (data && !Array.isArray(data) && typeof data === 'object' && data.chart_data == null) {
      const out = {};
      for (const k in data) {
        if (!Object.prototype.hasOwnProperty.call(data, k)) continue;
        const name = String(k || '').trim();
        if (!name || name.toLowerCase() === 'unknown') continue;
        const vRaw = data[k];
        const num = typeof vRaw === 'string' ? parseFloat(vRaw) : Number(vRaw || 0);
        if (!isFinite(num)) continue;
        out[name] = Math.round(num * 100) / 100;
      }
      return { percentMap: out, topLabels: [], topSeries: [], topPercents: [] };
    }

    if (data && data.chart_data && Array.isArray(data.chart_data.labels) && Array.isArray(data.chart_data.series)) {
      return computeTopDataFromArrays(data.chart_data.labels, data.chart_data.series);
    }
    if (data && Array.isArray(data.labels) && Array.isArray(data.series)) {
      return computeTopDataFromArrays(data.labels, data.series);
    }
    if (Array.isArray(data)) {
      const labels = [];
      const series = [];
      for (let i = 0; i < data.length; i++) {
        const row = data[i];
        if (!Array.isArray(row) || row.length < 2) continue;
        labels.push(String(row[0] || ''));
        series.push(Number(row[1] || 0));
      }
      return computeTopDataFromArrays(labels, series);
    }
    return { percentMap: {}, topLabels: [], topSeries: [], topPercents: [] };
  }

  function updateChartkick(mapData) {
    const ck = (window.Chartkick && window.Chartkick.charts) ? window.Chartkick.charts[chartId] : null;
    if (!ck || typeof ck.updateData !== 'function') throw new Error(`Chartkick chart not found: ${chartId}`);
    ck.updateData(mapData);
  }

  async function load(params, groupBy = 'country') {
    const url = `${endpoint}?${params.toString()}`;
    const res = await fetch(url, { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
    if (!res.ok) throw new Error(`Fetch failed ${res.status}`);
    const data = await res.json();
    const parsed = parseData(data);
    // Only update the map for country-level data
    if (String(groupBy || 'country') === 'country') {
      updateChartkick(parsed.percentMap);
    }
    return parsed;
  }

  return {
    async loadPreset(days = 7, groupBy = 'country') {
      const d = Number(days) || 7;
      const params = new URLSearchParams();
      params.append('chart_type', 'audience_downloads_by_location');
      params.append('date_range', 'all_time');
      params.append('group_by', String(groupBy || 'country'));
      return load(params, groupBy);
    },
    async loadCustom(from, to, groupBy = 'country') {
      const params = new URLSearchParams();
      params.append('chart_type', 'audience_downloads_by_location');
      params.append('date_range', 'custom');
      params.append('start_date', from);
      params.append('end_date', to);
      params.append('group_by', String(groupBy || 'country'));
      return load(params, groupBy);
    },
    destroy() {}
  };
}
